<template>
  <header
    class="bg-surface-light border-b border-surface-grey sticky top-0 z-50"
  >
    <BaseContainer>
      <div class="flex justify-between h-20 items-center">
        <RouterLink
          to="/"
          class="flex-shrink-0 flex items-center w-25 h-8 lg:w-50 lg:h-12"
        >
        <GlobalCustomerLogo />
        </RouterLink>

        <nav class="hidden md:flex justify-center h-full w-full">
          <div class="space-x-2 flex">
            <BaseDropdown
              ref="categoryDropdownRef"
              class="hidden md:inline-flex"
              :text="$t('globals.categories')"
              @on-change="() => closeOtherDropdowns('category')"
            >
              <CategoryFilter
                @on-change="categoryDropdownRef?.closeDropdown()"
              />
            </BaseDropdown>

            <BaseDropdown
              ref="locationDropdownRef"
              class="hidden md:inline-flex"
              :text="$t('globals.locations')"
              @on-change="() => closeOtherDropdowns('location')"
            >
              <LocationFilter
                @on-change="locationDropdownRef?.closeDropdown()"
              />
            </BaseDropdown>

            <BaseDropdown
              ref="dateDropdownRef"
              class="hidden md:inline-flex"
              :text="$t('globals.date')"
              @on-change="() => closeOtherDropdowns('date')"
            >
              <DateFilter @on-change="dateDropdownRef?.closeDropdown()" />
            </BaseDropdown>
          </div>
        </nav>

        <div class="flex items-center justify-center gap-2 lg:gap-4">
          <!--<GlobalLogin />-->
          <GlobalSearch />
          <GlobalSearchFilter />
          <GlobalCart />
        </div>
      </div>
    </BaseContainer>
  </header>
</template>

<script setup lang="ts">
  import { ref } from 'vue';

  import CategoryFilter from '@/components/filters/CategoryFilter.vue';
  import DateFilter from '@/components/filters/DateFilter.vue';
  import LocationFilter from '@/components/filters/LocationFilter.vue';
  import BaseDropdown from '@/components/ui/BaseDropdown.vue';

  import BaseContainer from '../ui/BaseContainer.vue';
  import GlobalCart from './GlobalCart.vue';
  import GlobalCustomerLogo from './GlobalCustomerLogo.vue';
  //import GlobalLogin from './GlobalLogin.vue';
  import GlobalSearch from './GlobalSearch.vue';
  import GlobalSearchFilter from './GlobalSearchFilter.vue';

  const categoryDropdownRef = ref<InstanceType<typeof BaseDropdown> | null>(
    null
  );
  const locationDropdownRef = ref<InstanceType<typeof BaseDropdown> | null>(
    null
  );
  const dateDropdownRef = ref<InstanceType<typeof BaseDropdown> | null>(null);


  function closeOtherDropdowns(except: string) {
    if (except !== 'category' && categoryDropdownRef.value) {
      categoryDropdownRef.value.closeDropdown();
    }
    if (except !== 'location' && locationDropdownRef.value) {
      locationDropdownRef.value.closeDropdown();
    }
    if (except !== 'date' && dateDropdownRef.value) {
      dateDropdownRef.value.closeDropdown();
    }
  }
</script>
